module.exports = __webpack_public_path__ + "img/2020_0.1ba0d64f.webp";